<script setup lang="ts">
import VButton from '@components/buttons/VButton/VButton.vue';
import VDownloadReportToast from '@modules/download-report/components/VDownloadReportToast/VDownloadReportToast.vue';
import { useUserSupervision } from '@modules/user/composables';

import type { IDownloadReportButtonEmits, IDownloadReportButtonProps } from './types';

defineProps<IDownloadReportButtonProps>();
defineEmits<IDownloadReportButtonEmits>();

const { isSupervision } = useUserSupervision();
</script>

<template>
  <VButton v-data-qa-auto-id="'VDownloadReportButton'"
    :disabled="isSupervision"
    :label="label"
    :loading="loading"
    icon="pi pi-download"
    @click="$emit('download')"
  />

  <VDownloadReportToast />
</template>
